import { hideLoadingScreen, showLoadingScreen } from "./loading-screen";

$(document).on('turbolinks:click', function() {
  showLoadingScreen()
});

$(document).on('turbolinks:load', function() {
  hideLoadingScreen()
});